import React, { useId, useState } from "react";

const SidebarAccordion = ({
  title,
  defaultOpen = true,
  children,
  className = "",
}) => {
  const reactId = useId();
  const baseId = `gf-acc-${reactId.replace(/:/g, "")}`;
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`gf-sidebar-accordion ${open ? "is-open" : ""} ${className}`.trim()}>
      <button
        type="button"
        className="gf-sidebar-accordion__trigger"
        aria-expanded={open}
        aria-controls={`${baseId}-panel`}
        id={`${baseId}-btn`}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="gf-sidebar-accordion__title">{title}</span>
        <span className="gf-sidebar-accordion__icon" aria-hidden="true">
          {open ? "▾" : "▸"}
        </span>
      </button>
      <div
        id={`${baseId}-panel`}
        role="region"
        aria-labelledby={`${baseId}-btn`}
        className="gf-sidebar-accordion__panel"
        hidden={!open}
      >
        {children}
      </div>
    </div>
  );
};

export default SidebarAccordion;
